// ハンバーガーボタン
document.addEventListener('DOMContentLoaded', function () {
  var menuBtn = document.querySelector('.header__menu');
  var links = document.querySelectorAll('a');

  menuBtn.addEventListener('click', function () {
    document.body.classList.toggle('open');
    document.body.classList.remove('open_search');
  });

  links.forEach(function (link) {
    link.addEventListener('click', function () {
      document.body.classList.remove('open');
    });
  });
});

// 検索ボタン
document.addEventListener('DOMContentLoaded', function () {
  var menuBtn = document.querySelector('.header__icon');
  var links = document.querySelectorAll('a');

  menuBtn.addEventListener('click', function () {
    document.body.classList.toggle('open_search');
    document.body.classList.remove('open');
  });

  links.forEach(function (link) {
    link.addEventListener('click', function () {
      document.body.classList.remove('open_search');
    });
  });
});

// swiper（TOPページ）
const swiper = new Swiper(".swiper", {
  slidesPerView: 1.25,
  loop: true,
  centeredSlides: true,
  breakpoints: {
    767: {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 0,

    }
  },

  pagination: {
    el: ".swiper-pagination"
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

// swiper（動画で学ぶページ）
var movieSlider = new Swiper('.movie-slider', {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  loop: true, // スライダーをループさせる
  slidesPerView: 1, // 1つのスライドを表示
  spaceBetween: 20, // スライド間のスペース
  autoplay: {
    delay: 4000, // 4秒間隔で自動スライド
    disableOnInteraction: false, // ユーザー操作後も自動スライドを継続
    pauseOnMouseEnter: true, // マウスホバー時に一時停止
    waitForTransition: false, // トランジション待機を無効化
    stopOnLastSlide: false, // 最後のスライドで停止しない
  },
  // レスポンシブ設定でSP表示を最適化
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true, // SP表示でセンタリング
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: false,
    }
  },
  // 初期化後に自動再生を確実に開始
  on: {
    init: function () {
      console.log('Movie Swiper initialized with autoplay');
      this.autoplay.start();
    },
  }
});

//条件絞り込み
// filter-linkをクリックしたときにactiveクラスを付与
var filterLink = document.querySelector('.filter-link');
if (filterLink) {
  filterLink.addEventListener('click', function (e) {
    e.preventDefault(); // デフォルトのリンク動作を無効化
    document.querySelector('.filter-panel').classList.add('active'); // activeクラスを追加
  });
}

// close-btnをクリックしたときにactiveクラスを外す
var closeBtn = document.querySelector('.close-btn');
if (closeBtn) {
  closeBtn.addEventListener('click', function () {
    document.querySelector('.filter-panel').classList.remove('active'); // activeクラスを削除
  });
}


for (let p = 1; p <= 10; p++) {
  let p_element_id = `dept_${p}`;
  for (let i = 1; i <= 30; i++) {
    let element_id = `sub_${p_element_id}_${i}`;
    let checkbox = document.getElementById(element_id);
    if (checkbox !== null) {
      checkbox.classList.add(`p_${p_element_id}`); //
      checkbox.setAttribute('parent', p_element_id); //
    }
  }
}

//カテゴリに応じて条件絞り込みの中身を変更
document.querySelectorAll('.js-cat-item').forEach(item => {
  item.addEventListener('change', function (e) {
    // すべての対象要素を非表示
    document.querySelectorAll('.js-corner, .js-description, .js-author, .js-series').forEach(el => el.style.display = 'none');

    // 選択されたチェックボックスを取得
    const isCornerChecked = document.querySelector('#cat_1').checked;
    const isDetailsChecked = document.querySelector('#cat_2').checked;

    if (isCornerChecked && isDetailsChecked) {
      // 両方にチェックが入っている場合、すべて表示
      document.querySelectorAll('.js-corner, .js-description, .js-author, .js-series').forEach(el => el.style.display = 'block');
    } else if (isCornerChecked) {
      // "Web医事新報を読む" のみチェックされている場合、コーナーを表示
      document.querySelectorAll('.js-corner').forEach(el => el.style.display = 'block');
    } else if (isDetailsChecked) {
      // "商品を探す・購入する" のみチェックされている場合、詳細情報を表示
      document.querySelectorAll('.js-description, .js-author, .js-series').forEach(el => el.style.display = 'block');
    }

    if (!isCornerChecked) {
      const corner = document.getElementById('corner');
      corner.selectedIndex = 0;
      delete selectedData['corner'];
    }

    if (!isDetailsChecked) {
      const description = document.getElementById('description');
      description.value = '';
      const editor = document.getElementById('editor');
      editor.value = '';
      const series = document.getElementById('series');
      series.selectedIndex = 0;
      delete selectedData['description'];
      delete selectedData['editor'];
      delete selectedData['series'];
    }

    setInputData();

  });
});


let selectedData = {};

let formElements = document.querySelectorAll('.filter-panel input, .filter-panel select');
formElements.forEach(element => {
  element.addEventListener('change', function () {
    let id = this.id;
    let value = '';

    if (this.type === 'checkbox') {
      console.log(this.classList.contains('ch-parent'));
      //if(!this.classList.contains('ch-parent')) {
      let label = document.querySelector(`label[for="${id}"]`);
      let parent = element.getAttribute('parent');
      let parent_name = '';
      if (parent) {
        let parent_label = document.querySelector(`label[for="${parent}"]`);
        if (parent_label) {
          parent_name = parent_label.textContent.trim();
        }
      }

      if (label) {
        value = label.textContent.trim();
        if (this.checked) {
          selectedData[id] = parent_name ? `${parent_name} > ` + value : value;
        } else {
          delete selectedData[id];
        }
      }
      //}
    } else if (this.tagName === 'INPUT' || this.tagName === 'TEXTAREA') {
      value = this.value.trim();
      if (value !== '') {
        selectedData[id] = value;
      } else {
        delete selectedData[id];
      }
    } else if (this.tagName === 'SELECT') {
      value = this.value.trim();
      if (value !== '') {
        selectedData[id] = value;
      } else {
        delete selectedData[id];
      }
    }

    let orderedData = {};
    formElements.forEach(el => {
      if (selectedData.hasOwnProperty(el.id)) {
        orderedData[el.id] = selectedData[el.id];
      }
    });
    selectedData = orderedData;

    setInputData();
  });
});

let parentCheckBoxs = document.querySelectorAll('.filter-panel .ch-parent');
parentCheckBoxs.forEach(element => {
  element.addEventListener('change', function () {
    if (!this.checked) {
      for (let i = 1; i <= 30; i++) {
        let child_id = `sub_${this.id}_${i}`;
        const element = document.getElementById(child_id);
        if (element) {
          element.checked = false;
          delete selectedData[child_id];
        }
        setInputData();
      }
    }
  });
});

function setInputData() {
  const ulElement = document.getElementById('selectedTags');
  ulElement.innerHTML = '';

  Object.entries(selectedData).forEach(([key, value]) => {
    const li = document.createElement('li');
    li.textContent = value;
    const a = document.createElement('a');
    a.classList.add('remove-item');
    a.setAttribute('item', key);
    a.textContent = '×';
    a.addEventListener('click', function () {
      let element_id = this.getAttribute('item');
      delete selectedData[element_id];
      setInputData();

      const element = document.getElementById(element_id);
      if (!element) {
        return;
      }
      if (element.type === "checkbox") {
        element.checked = false;
      }
      else if (element.type === "text" || element.type === "password" || element.type === "email" || element.type === "number") {
        element.value = "";
      }
      else if (element.tagName === "SELECT") {
        element.selectedIndex = 0;
      }
    });

    li.append(a);
    ulElement.appendChild(li);
  });

  if (Object.values(selectedData).length != 0) {
    const li = document.createElement('li');
    li.textContent = 'すべてリセット';
    const a = document.createElement('a');
    a.classList.add('reset-items');
    a.textContent = '×';

    a.addEventListener('click', function () {
      selectedData = {};
      setInputData();

      const checkboxes = document.querySelectorAll('.filter-panel input[type="checkbox"]');
      const inputs = document.querySelectorAll('.filter-panel input[type="text"]');
      const selects = document.querySelectorAll('.filter-panel select');

      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      inputs.forEach(input => {
        input.value = "";
      });
      selects.forEach(select => {
        select.selectedIndex = 0;
      });

    });

    li.append(a);
    ulElement.appendChild(li);
  }
}

// タブ
document.addEventListener('DOMContentLoaded', function () {
  // 共通の関数を作成

  /* Tab */
  var buttons = document.querySelectorAll('.tab-btn');
  if (buttons.length) {
    buttons.forEach(button => {
      button.addEventListener('click', function (event) {
        var tabs = event.target.parentElement.children;
        let selectedTabIndex = event.target.getAttribute('tab-index');
        for (var i = 0; i < tabs.length; i++) {
          tabs[i].classList.remove('active');
          let tabIndex = tabs[i].getAttribute('tab-index');
          if (selectedTabIndex !== tabIndex) {
            var tabContent = document.getElementById('tab_content_' + tabIndex);
            tabContent.classList.add('hidden');
          }
        }

        if (selectedTabIndex === 'kyujin' || selectedTabIndex === 'bukken') {
          var btnAddCondition = document.getElementById('btn_add_condition');
          if (btnAddCondition) {
            btnAddCondition.setAttribute('tab', selectedTabIndex);
            checkAdditionCondition();
          }
        }
        // クリックされた要素にactiveクラスを付与
        event.target.classList.add('active');
        var selectedTabContent = document.getElementById('tab_content_' + selectedTabIndex);
        selectedTabContent.classList.remove('hidden');
      });
    });
  }

  function accordionProcess(event, accordionClass, accordionContentClass, openName, closeName) {
    if (event.target.classList.contains("common-buttons__button-accordion--open")) {
      event.target.classList.add('common-buttons__button-accordion--close');
      event.target.textContent = openName;

      event.target.classList.remove('common-buttons__button-accordion--open');
      var allContents = document.querySelectorAll(accordionContentClass);
      allContents.forEach(function (content) {
        content.style.display = 'none';
        content.classList.add('hidden');
      });

      if (accordionClass == '.accordion-condition') {
        var divideContents = document.querySelectorAll('.accordion-condition-divide');
        divideContents.forEach(function (content) {
          content.classList.add('search-box__field--bottom-border');
        });
      }
    } else {
      event.target.classList.add('common-buttons__button-accordion--open');
      event.target.classList.remove('common-buttons__button-accordion--close');
      event.target.textContent = closeName;
      var activeContents = document.querySelectorAll(accordionContentClass);
      activeContents.forEach(function (content) {
        content.style.display = 'inline-table';
        content.classList.remove('hidden');
      });

      if (accordionClass == '.accordion-condition') {
        var divideContents = document.querySelectorAll('.accordion-condition-divide');
        divideContents.forEach(function (content) {
          content.classList.remove('search-box__field--bottom-border');
        });
      }
    }
  }
  /* 勤務地 アコーディオン*/
  var buttons = document.querySelectorAll('.accordion-work-place');
  if (buttons.length) {
    buttons.forEach(button => {
      button.addEventListener('click', function (event) {
        accordionProcess(event, '.accordion-work-place', '.accordion-work-place-content', '勤務地を選択する', '勤務地の選択を閉じる');
      });
    });
  }

  /* 募集科目 アコーディオン*/
  var buttons = document.querySelectorAll('.accordion-app-department');
  if (buttons.length) {
    buttons.forEach(button => {
      button.addEventListener('click', function (event) {
        accordionProcess(event, '.accordion-app-department', '.accordion-app-department-content', '募集科目を選択する', '募集科目の選択を閉じる');
      });
    });
  }

  /* 所在地 アコーディオン*/
  var buttons = document.querySelectorAll('.accordion-address');
  if (buttons.length) {
    buttons.forEach(button => {
      button.addEventListener('click', function (event) {
        accordionProcess(event, '.accordion-address', '.accordion-address-content', '所在地を選択する', '所在地の選択を閉じる');
      });
    });
  }

  /* 条件 アコーディオン*/
  var buttons = document.querySelectorAll('.accordion-condition');
  if (buttons.length) {
    buttons.forEach(button => {
      button.addEventListener('click', function (event) {
        accordionProcess(event, '.accordion-condition', '.accordion-condition-content', '条件を追加する', '条件の追加を閉じる');
        checkAdditionCondition();
      });
    });
  }

  function checkAdditionCondition() {
    var pAddingcondition = document.getElementById('v_adding_condition');

    var btnAdditionAccordion = document.getElementById('btn_add_condition');

    var tab = btnAdditionAccordion.getAttribute('tab');
    if (btnAdditionAccordion.classList.contains("common-buttons__button-accordion--close")) {
      var tabClassName = '.sagasu-tab-' + tab;

      const inputs = document.querySelectorAll(tabClassName + ' input');
      let hasFilledOrChecked = false;

      inputs.forEach(input => {
        if ((input.type === 'text' && input.value.trim() !== '') ||
          (input.type === 'checkbox' && input.checked)) {
          hasFilledOrChecked = true;
        }
      });

      if (hasFilledOrChecked) {
        pAddingcondition.classList.remove('hidden');
      } else {
        pAddingcondition.classList.add('hidden');
      }
    } else {
      pAddingcondition.classList.add('hidden');
    }
  }

  function subAccordionProcess(accordion, event, accordionClass) {
    const beforeStyle = window.getComputedStyle(accordion, '::before');

    if (beforeStyle && beforeStyle.display !== 'none') {
      var openClass = accordionClass + "--open";
      var closeClass = accordionClass + "--close";
      var accordionContent = document.getElementById(accordion.getAttribute('accordion-element'));

      if (accordion.classList.contains(openClass)) {
        accordion.classList.add(closeClass);
        accordion.classList.remove(openClass);
        accordionContent.style.display = 'none';
      } else {
        accordion.classList.add(openClass);
        accordion.classList.remove(closeClass);
        accordionContent.style.display = 'block';
      }
    }
  }
  /* Subアコーディオン*/
  var sub_accordions = document.querySelectorAll('.section--accordion');
  if (sub_accordions.length) {
    sub_accordions.forEach(accordion => {
      accordion.addEventListener('click', function (event) {
        subAccordionProcess(accordion, event, 'section--accordion');
      });
    });
  }

  //マイページアコーディオン
  function menuAccordionProcess(accordion, event) {
    const beforeStyle = window.getComputedStyle(accordion, '::before');
    var index = accordion.getAttribute('accordion-index');

    if (beforeStyle && beforeStyle.display !== 'none') {
      var accordionContent = document.getElementById('accordion_content_' + index);

      if (accordion.classList.contains('accordion--open')) {
        accordion.classList.add('accordion--close');
        accordion.classList.remove('accordion--open');
        accordionContent.style.display = 'none';
      } else {
        accordion.classList.add('accordion--open');
        accordion.classList.remove('accordion--close');
        accordionContent.style.display = 'block';
      }
    }
  }

  var mypageAccordions = document.querySelectorAll('.my-menu .accordion');
  if (mypageAccordions.length) {
    mypageAccordions.forEach(accordion => {
      accordion.addEventListener('click', function (event) {
        menuAccordionProcess(accordion, event);
      });
    });
  }

});


//メガメニュー
document.addEventListener('DOMContentLoaded', function () {
  // 関数を使ってクリック時の挙動をまとめる
  function toggleActive(navSelector, contentSelector) {
    var navElement = document.querySelector(navSelector);
    var contentElement = document.querySelector(contentSelector);

    navElement.addEventListener('click', function () {
      // すでにactiveがついている場合、クラスを外す
      if (navElement.classList.contains('active')) {
        navElement.classList.remove('active');
        if (contentElement) {
          contentElement.classList.remove('active');
        }
      } else {
        // すべてのmega-menu__contentからactiveを削除
        document.querySelectorAll('.mega-menu__wrap').forEach(function (content) {
          content.classList.remove('active');
        });

        // すべてのnav要素からactiveを削除
        document.querySelectorAll('.header__nav__info, .header__nav__column, .header__nav__book, .header__nav__movie, .header__nav__medical').forEach(function (nav) {
          nav.classList.remove('active');
        });

        // 対応するコンテンツにactiveを追加
        if (contentElement) {
          contentElement.classList.add('active');
        }

        // クリックしたナビゲーション要素にactiveを追加
        navElement.classList.add('active');
      }
    });
  }

  // スクロール時にactiveクラスをすべて削除する関数
  function removeActiveOnScroll() {
    document.querySelectorAll('.mega-menu__wrap, .header__nav__info, .header__nav__column, .header__nav__book, .header__nav__movie, .header__nav__medical').forEach(function (element) {
      element.classList.remove('active');
    });
  }

  // Bodyクリック時にactiveクラスをすべて削除する関数
  function removeActiveOnClickBody() {
    // mega-menu__wrapがactiveクラスを持っているかチェック
    var isActive = Array.from(document.querySelectorAll('.mega-menu__wrap')).some(function (element) {
      return element.classList.contains('active');
    });

    // activeクラスが存在する場合のみ削除処理を行う
    if (isActive) {
      document.querySelectorAll('.mega-menu__wrap, .header__nav__info, .header__nav__column, .header__nav__book, .header__nav__movie, .header__nav__medical').forEach(function (element) {
        element.classList.remove('active');
      });
    }
  }


  // メニュー以外をクリックしたときにメニューを閉じる関数
  function removeActiveOnClickBody(event) {
    // クリックした要素がメニュー関連でなければ閉じる
    if (!event.target.closest('.header__nav, .mega-menu__wrap')) {
      document.querySelectorAll('.mega-menu__wrap, .header__nav__info, .header__nav__column, .header__nav__book, .header__nav__movie, .header__nav__medical').forEach(function (element) {
        element.classList.remove('active');
      });
    }
  }

  // メニュー以外の場所をクリックした場合メニューを閉じる
  document.addEventListener('click', removeActiveOnClickBody);


  // 各ナビゲーション要素とコンテンツ要素を対応させて呼び出す
  toggleActive('.header__nav__info', '.mega-menu__wrap__info');
  toggleActive('.header__nav__column', '.mega-menu__wrap__column');
  // toggleActive('.header__nav__book', '.mega-menu__wrap__book');
  // toggleActive('.header__nav__movie', '.mega-menu__wrap__movie');
  // toggleActive('.header__nav__medical', '.mega-menu__wrap__medical');

  // スクロール時にすべてのactiveクラスを削除
  window.addEventListener('scroll', removeActiveOnScroll);

  // bodyクリック時にすべてのactiveクラスを削除
  // document.body.addEventListener('click', removeActiveOnClickBody);
});

const subImages = document.querySelectorAll('.sub-images img');

if (subImages.length) {
  subImages.forEach(image => {
    image.addEventListener('click', function () {
      // Get the main image element
      const mainImage = document.getElementById('job_main_image');
      // Change the src of the main image to the clicked sub-image's src
      mainImage.src = this.src;
    });
  });

}

const areaCheckboxes = document.querySelectorAll('.ch-area');
if (areaCheckboxes.length > 0) {
  areaCheckboxes.forEach(areaCheckbox => {
    areaCheckbox.addEventListener('change', function () {
      var area = areaCheckbox.getAttribute('check-part');
      var page = areaCheckbox.getAttribute('check-page');
      if (area === "domestic") {
        for (var i = 0; i <= 10; i++) {
          const prefCheckbox = document.getElementById('ch_' + page + '_' + i);
          if (prefCheckbox) {
            prefCheckbox.checked = this.checked;

            var part = prefCheckbox.getAttribute('check-part');
            var subCheckboxes = document.querySelectorAll('.ch-' + part);
            subCheckboxes.forEach(subCheckbox => {
              subCheckbox.checked = this.checked;
            });
            initSelectedSubCheckBox(part);
          }
        }
      }
      getAllCheckedSubLabels(page);
    });
  });
}

const mainCheckboxes = document.querySelectorAll('.ch-all');
if (mainCheckboxes.length > 0) {
  mainCheckboxes.forEach(mainCheckbox => {
    mainCheckbox.addEventListener('change', function () {
      var part = mainCheckbox.getAttribute('check-part');
      var page = mainCheckbox.getAttribute('check-page');
      var subCheckboxes = document.querySelectorAll('.ch-' + part);
      subCheckboxes.forEach(subCheckbox => {
        subCheckbox.checked = this.checked;
      });
      initAreaFullCheck(page);
      initSelectedSubCheckBox(part);
    });
  });
}

function initAreaFullCheck(page) {
  var fullCheck = true;
  for (var i = 0; i <= 10; i++) {
    const prefCheckbox = document.getElementById('ch_' + page + '_' + i);
    if (prefCheckbox) {
      if (!prefCheckbox.checked) {
        fullCheck = false;
      }
    }
  }

  const domesticCheckbox = document.getElementById('ch_domestic');
  domesticCheckbox.checked = fullCheck;
}

function initSelectedSubCheckBox(child) {
  var strCheck = "";
  const mainCheckbox = document.getElementById('ch_' + child);
  if (!mainCheckbox.checked) {
    var subCheckboxes = document.querySelectorAll('.ch-' + child);
    subCheckboxes.forEach(subCheckbox => {
      if (subCheckbox.checked) {
        var text = getCheckboxLabel(subCheckbox);
        if (strCheck === "") {
          strCheck = text;
        } else {
          strCheck += "／" + text;
        }
      }
    });
  }

  const viewer = document.getElementById('selected_' + child);
  if (viewer) {
    viewer.innerHTML = strCheck;
  }

  if (child.includes('area')) {
    getAllCheckedSubLabels('area');
  }

  if (child.includes('department')) {
    getAllCheckedSubLabels('department');
  }

  if (child.includes('place')) {
    getAllCheckedSubLabels('place');
  }
}

function getCheckboxLabel(checkbox) {
  const label = checkbox.nextElementSibling;
  if (label && label.tagName.toLowerCase() === 'label') {
    return label.textContent;
  } else {
    return '';
  }
}

function getAllCheckedSubLabels(part) {
  strCheck = "";
  var addSub = true;

  if (part === "area" || part === "place") {
    const domesticCheckbox = document.getElementById('ch_domestic');
    if (domesticCheckbox) {
      if (domesticCheckbox.checked) {
        strCheck = getCheckboxLabel(domesticCheckbox);
        addSub = false;
      }
    }

    const abroadCheckbox = document.getElementById('ch_abroad');
    if (abroadCheckbox) {
      if (abroadCheckbox.checked) {
        var text = getCheckboxLabel(abroadCheckbox);
        if (strCheck === "") {
          strCheck = text;
        } else {
          strCheck += "／" + text;
        }
      }
    }
  }

  if (addSub) {
    for (var i = 0; i <= 10; i++) {
      const mainCheckbox = document.getElementById('ch_' + part + '_' + i);
      if (mainCheckbox) {
        if (mainCheckbox.checked) {
          var text = getCheckboxLabel(mainCheckbox);
          if (strCheck === "") {
            strCheck = text;
          } else {
            strCheck += "／" + text;
          }
        } else {
          var subCheckboxes = document.querySelectorAll('#' + part + '_' + i + ' .ch-item');
          if (subCheckboxes.length > 0) {
            subCheckboxes.forEach(subCheckbox => {
              if (subCheckbox.checked) {
                var text = getCheckboxLabel(subCheckbox);
                if (strCheck === "") {
                  strCheck = text;
                } else {
                  strCheck += "／" + text;
                }
              }
            });
          }

        }
      }
    }
  }

  const viewer = document.getElementById('selected_' + part);
  if (viewer) {
    viewer.parentElement.classList.remove('hidden');
    viewer.innerHTML = strCheck;
  } else {
    viewer.parentElement.classList.add('hidden');
  }
}

//よくある質問　アコーディオン
document.querySelectorAll('.qa-item__q').forEach(function (question) {
  question.addEventListener('click', function () {
    var answer = this.nextElementSibling;

    if (answer.style.maxHeight) {
      // 開いている場合
      answer.style.maxHeight = null;
    } else {
      // 閉じている場合
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }

    this.querySelector('.qa-item__icon').classList.toggle('is-open');
  });
});
